import React from 'react';

import ExtrasPanel from './panels/ExtrasPanel';
import HeaderPanel from './panels/HeaderPanel';
import LearningPanel from './panels/LearningPanel';
import MessagesPanel from './panels/MessagesPanel';
import SchedulePanel from './panels/SchedulePanel';
import ZmanimPanel from './panels/ZmanimPanel';

const publicUrl = process.env.PUBLIC_URL || '';
const backgroundAssets = {
  '--bg-desktop-avif': `url("${publicUrl}/assets/bg.avif")`,
  '--bg-desktop-webp': `url("${publicUrl}/assets/bg.webp")`,
  '--bg-mobile-avif': `url("${publicUrl}/assets/bg-mobile.avif")`,
  '--bg-mobile-webp': `url("${publicUrl}/assets/bg-mobile.webp")`
};

export default function InfoScreenLayout({
  data,
  currentMessage,
  isInitialLoading,
  previewScenario = ''
}) {
  const showsMessagesPanel = data.privacy?.showsMessagesPanel === true;
  const scheduleVariant = showsMessagesPanel ? 'timeline' : 'overview';

  return (
    <div
      className="App"
      dir="rtl"
      data-layout="dashboard"
      data-privacy-mode={data.privacy?.mode || 'external'}
      data-messages-panel={showsMessagesPanel ? 'visible' : 'hidden'}
      data-preview-scenario={previewScenario || undefined}
      style={backgroundAssets}
    >
      <div className="row screen-grid">
        <div className="container screen-left-column">
          <ZmanimPanel data={data} loading={isInitialLoading} />
          <LearningPanel learn={data.learn} loading={isInitialLoading} />
          <ExtrasPanel extras={data.extras} loading={isInitialLoading} />
        </div>
        <div className="container screen-right-column">
          <HeaderPanel days={data.days} isNight={data.isNight} description={data.description} />
          <div className={`row screen-bottom-row screen-bottom-row--dashboard-timeline${showsMessagesPanel ? ' screen-bottom-row--with-messages' : ' screen-bottom-row--without-messages'}`}>
            {showsMessagesPanel ? (
              <MessagesPanel message={currentMessage} metadata={data.metadata} loading={isInitialLoading} />
            ) : null}
            <div className={`container schedule-container schedule-container--${scheduleVariant}`}>
              <SchedulePanel
                days={data.days}
                loading={isInitialLoading}
                variant={scheduleVariant}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
